import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {
  LinkIcon,
} from '../../components'
import Styles from './IyvListTutorial.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTutorialRestartButton extends Component {
  static propTypes = {
    clickTutorialRestart: PropTypes.func,
  }
  //
  constructor(props) {
    super(props)
  }
  //

  render() {
    return <button
      styleName='tutorial-wrap-restart'
      onClick={this.props.clickTutorialRestart}
      role='button'
      tabIndex='0'
    >
      <LinkIcon faclass='fa-info-circle' nospace />
      &nbsp;
      Show me how this works
    </button>
  }
}
